import { useParams } from '@tanstack/react-router';
import { FormAction } from '@anytag/shared-types';
import { getRestApiUrl } from '@anytag/shared-utils';
import { useToggleState, useDownloadFile } from '@anytag/shared-hooks';
import {
  getDownloadCSVRangeRows,
  DownloadCsvPagesAndRowsModal,
  DownloadCsvPagesAndRowsModalValues
} from '@anytag/shared-molecules';
import { useYoutubeCMSFilter } from '../../hooks';
import { YoutubeCMSSegmentMode } from '../../types';

export const useDownloadYoutubeCMSCsv = () => {
  const params = useParams({ strict: false });
  const csvModal = useToggleState();
  const { downloading, handleDownloadFile } = useDownloadFile();
  const {
    limit,
    filter: { segment, keyword, month }
  } = useYoutubeCMSFilter();

  const cmsChannelId = params?.cmsChannelId || '';
  const isSegmentAssets = segment === YoutubeCMSSegmentMode.ASSETS;

  const handleDownloadCsv: FormAction<DownloadCsvPagesAndRowsModalValues>['onSubmit'] = async (formValues) => {
    const { firstRow, lastRow } = getDownloadCSVRangeRows(formValues);

    await handleDownloadFile({
      method: 'GET',
      filenamePrefix: `youtube-cms-${new Date().toUTCString()}`,
      url: getRestApiUrl(isSegmentAssets ? 'cms/assets/csv/' : 'cms/channels/csv/'),
      params: { firstRow, lastRow, keyword, month, ...(isSegmentAssets && cmsChannelId ? { cmsChannelId } : {}) }
    });

    csvModal.close();
  };

  return {
    openDownloadModal: csvModal.open,
    DownloadCsvModal: (
      <DownloadCsvPagesAndRowsModal
        limit={limit}
        maxRows={1000}
        open={csvModal.status}
        onClose={csvModal.close}
        downloading={downloading}
        onSubmit={handleDownloadCsv}
      />
    )
  };
};
